<template>
  <div>
    <SubnetDetail ref="SubnetDetail"></SubnetDetail>
    <CreateSubnet ref="CreateSubnet" v-on:createComplete="getSubnets()"></CreateSubnet>
    <Alert v-if="subnets.error" type="warning" show-icon>获取子网数据失败</Alert>
    <div v-else>
      <Table
        border
        size="small"
        :loading="subnets.loading"
        ref="subnetTable"
        :data="subnets.data"
        :columns="subnets.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="subnets.count"
            :current="subnets.page"
            :page-size="subnets.size"
            @on-change="getSubnets"></page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPrivateCloudSubnet, deletePrivateCloudSubnet } from '@/api/private-cloud/subnet'
import CreateSubnet from './create-subnet'
import SubnetDetail from './subnet-detail'

export default {
  name: 'subnet-list',
  components: {
    CreateSubnet,
    SubnetDetail
  },
  data () {
    return {
      subnets: {
        data: [],
        columns: [
          {
            title: '子网名称',
            align: 'center',
            minWidth: 200,
            tooltip: true,
            key: 'name'
          },
          {
            title: 'CIDR',
            align: 'center',
            minWidth: 160,
            tooltip: true,
            key: 'cidr'
          },
          {
            title: 'IP版本',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'ip_version',
            render: (h, params) => {
              return h('span', 'IPv' + params.row.ip_version)
            }
          },
          {
            title: '网关IP',
            align: 'center',
            minWidth: 150,
            tooltip: true,
            key: 'gateway_ip'
          },
          {
            title: 'IP地址池',
            align: 'center',
            minWidth: 270,
            key: 'allocation_pools',
            render: (h, params) => {
              const pools = params.row.allocation_pools
              let result = []
              for (let i in pools) {
                result.push(h('p', '开始：' + pools[i].start + ' - 结束：' + pools[i].end))
              }
              return h('div', result)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 190,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.SubnetDetail.getInfo(params.row.id)
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.CreateSubnet.openModifyModal(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        error: false,
        loading: false
      },
      contentTypeId: '',
      operateLogs: [],
      LogsModel: false
    }
  },
  props: {
    network_id: {
      type: String,
      required: true
    }
  },
  watch: {
    'network_id' () {
      if (this.network_id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getSubnets()
    },
    getSubnets (value = 1) {
      this.subnets.page = value
      this.subnets.loading = true
      getPrivateCloudSubnet({ network_id: this.network_id, page: this.subnets.page, size: this.subnets.size }).then(res => {
        this.subnets.error = false
        let result = res.data
        this.subnets.data = result.results
        this.subnets.count = result.count
        this.subnets.loading = false
      }).catch(res => {
        this.subnets.error = true
        this.subnets.loading = false
      })
    },
    // 删除子网
    delete (row) {
      deletePrivateCloudSubnet(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getSubnets()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
